import { styled } from '@mui/system';
import { Box, TextField } from '@mui/material';

export const ModalContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const StyledTextField = styled(TextField)(() => ({
  marginBottom: 2,
  width: '100%',
  '& .MuiInputBase-input': {
    color: 'white',
    overflow: 'auto',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.23)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
}));
